module.exports = __webpack_public_path__ + "img/gamesdk8.a31f474.png";